import { Select } from "../../components/ui/Input";
import { useSession } from "../auth/useSession";
import { useStaffTenants, useSwitchTenant } from "./useStaffTenants";

/**
 * Only a staff session ever receives one of these, so its presence is the whole
 * signal that you are looking at someone else's store. Merchants never see it.
 */
export const StorePicker = () => {
	const { data } = useSession();
	const staff = data?.staff ?? null;
	const tenants = useStaffTenants(Boolean(staff));
	const switchTenant = useSwitchTenant();

	if (!data || !staff) return null;

	const current = {
		id: data.tenant.id,
		name: data.tenant.name,
		shopDomain: data.tenant.shopDomain,
		status: data.tenant.status,
	};
	const options = tenants.data?.items ?? [current];

	return (
		<label className="block border-t border-line px-3 py-3">
			<span className="sr-only">Store</span>
			<Select
				className="h-8 text-xs"
				value={data.tenant.id}
				disabled={switchTenant.isPending || tenants.isPending}
				onChange={(event) => switchTenant.mutate(event.target.value)}
			>
				{options.map((tenant) => (
					<option key={tenant.id} value={tenant.id}>
						{tenant.name ?? tenant.shopDomain}
						{tenant.status === "active" ? "" : ` · ${tenant.status}`}
					</option>
				))}
			</Select>
		</label>
	);
};
